import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const TrashAlt = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6H16V5C16 3.3 14.7 2 13 2H11C9.3 2 8 3.3 8 5V6H4C3.4 6 3 6.4 3 7C3 7.6 3.4 8 4 8H5V19C5 20.7 6.3 22 8 22H16C17.7 22 19 20.7 19 19V8H20C20.6 8 21 7.6 21 7C21 6.4 20.6 6 20 6ZM10 5C10 4.4 10.4 4 11 4H13C13.6 4 14 4.4 14 5V6H10V5ZM11 17C11 17.6 10.6 18 10 18C9.4 18 9 17.6 9 17V11C9 10.4 9.4 10 10 10C10.6 10 11 10.4 11 11V17ZM15 17C15 17.6 14.6 18 14 18C13.4 18 13 17.6 13 17V11C13 10.4 13.4 10 14 10C14.6 10 15 10.4 15 11V17Z"
      fill="currentColor"
    />
  </svg>
)

export default TrashAlt
